<app-component-loading-indicator></app-component-loading-indicator>
<app-header></app-header>
<app-sub-header></app-sub-header>
<main id="content">
    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>
</main>
<app-footer></app-footer>